export class ScreeningParty {
    cinejoyFeaturedMovie: number;
    mobileNumber: string;
    meetingCapacity: number;
    meetingLink: string;
    meetingDateTime: string;
    meetingLocalDateTime: string;
    description: string;
    screeningPartyType: ScreeningPartyType;
    meetingType: MeetingType;
}

export enum ScreeningPartyType {
    SPOTLIGHT= 'Spotlight', SHOWCASE= 'Showcase'
}

export enum MeetingType {
    ZOOM= 'Zoom', GATHER_TOWN= 'Gather.town'
}
